import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  checkUniqueBranchNameApi,
  checkUniqueClientGroupNameApi,
  checkUniqueCodeApi,
  checkUniquePdfTemplateApi,
  createMasterDataActivityCodeApi,
  createMasterDataBranchApi,
  createMasterDataClientCategoryApi,
  createMasterDataClientGroupApi,
  createMasterDataCurrencyApi,
  createMasterDataEmailersApi,
  createMasterDataHolidayCalenderApi,
  createMasterDataJobTitleApi,
  createMasterDataQualificationModuleApi,
  createMasterDataScopeOfWorkApi,
  createMasterDataSkillsModuleApi,
  createMasterDataUsersDepartmentApi,
  createMasterPdfTemplateApi,
  createMasterTcsModuleApi,
  createMasterTdsModuleApi,
  deleteHolidayCalenderApi,
  deleteMasterDataJobTitleApi,
  deleteMasterDataQualificationApi,
  deleteMasterDataScopeOfWorkApi,
  deleteMasterDataSkillsApi,
  deleteMasterDataUsersDepartmentApi,
  deleteMasterPdfTemplateApi,
  deleteMasterTcsModuleApi,
  deleteMasterTdsModuleApi,
  getAllCityApi,
  getAllCountryApi,
  getAllMasterDataActivityCodeListApi,
  getAllMasterDataBranchListApi,
  getAllMasterDataCurrencyListApi,
  getAllStateApi,
  getCurrnecyExchangeApi,
  getMasterDataActivityCodeApi,
  getMasterDataBranchApi,
  getMasterDataClientCategoryApi,
  getMasterDataClientGroupApi,
  getMasterDataCurrencyApi,
  getMasterDataEmailersApi,
  getMasterDataHolidayCalenderApi,
  getMasterDataJobTitleApi,
  getMasterDataQualificationModuleApi,
  getMasterDataScopeOfWorkApi,
  getMasterDataSkillsModuleApi,
  getMasterDataUsersDepartmentApi,
  getMasterPdfTemplateApi,
  getMasterTcsModuleApi,
  getMasterTcsModuleSingleApi,
  getMasterTdsModuleApi,
  getMasterTdsModuleSingleApi,
  updateMasterDataActivityCodeApi,
  updateMasterDataBranchApi,
  updateMasterDataClientCategoryApi,
  updateMasterDataClientGroupApi,
  updateMasterDataCurrencyApi,
  updateMasterDataEmailersApi,
  updateMasterDataHolidayCalenderApi,
  updateMasterDataJobTitleApi,
  updateMasterDataQualificationModuleApi,
  updateMasterDataScopeOfWorkApi,
  updateMasterDataSkillsModuleApi,
  updateMasterDataUsersDepartmentApi,
  updateMasterPdfTemplateApi,
  updateMasterTcsModuleApi,
  updateMasterTdsModuleApi,
} from "../../apis/masterDataApi";

import {
  AddClientCategoryPayloadType,
  AddJobTitlePayloadType,
  AddPdfTemplatePayloadType,
  AddQualificationPayloadType,
  AddSkillsPayloadType,
  AddUsersDepartmentPayloadType,
  CreateActivityCodeDataPayloadType,
  CreateBranchDataPayloadType,
  CreateClientGroupDataPayloadType,
  CreateCurrencyDataPayloadType,
  CreateEmailersDataPayloadType,
  CreateHolidayCalenderPayloadType,
  DeleteHolidayCalenderPayloadType,
  DeleteJobTitlePayloadType,
  DeletePdfTemplatePayloadType,
  DeleteQualificationPayloadType,
  DeleteSkillsPayloadType,
  DeleteTcsPayloadType,
  DeleteTdsPayloadType,
  DeleteUsersDepartmentPayloadType,
  GetAllMasterDataActivityCodePayloadType,
  GetAllMasterDataBranchPayloadType,
  GetAllMasterDataCurrencyPayloadType,
  GetCityListDataPayloadType,
  GetClientCategoryPayloadType,
  GetClientGroupDataPayloadType,
  GetCountryListDataPayloadType,
  GetCurrencyExchangeDetailsPayloadType,
  GetEmailerDataPayloadType,
  GetHolidayCalenderPayloadType,
  GetJobTitlePayloadType,
  GetMasterDataListPayloadType,
  GetStateListDataPayloadType,
  GetTdsMasterPayloadType,
  GetUsersDepartmentPayloadType,
  TcsInfoType,
  TcsSinglePayloadType,
  TdsInfoType,
  TdsSinglePayloadType,
  UniqueCheckCodePayloadType,
  UniqueClientGroupNamePayloadType,
  UniqueMasterDataPayloadType,
  UpdateActivityCodeDataPayloadType,
  UpdateBranchDataPayloadType,
  UpdateClientCategoryPayloadType,
  UpdateClientGroupDataPayloadType,
  UpdateCurrencyDataPayloadType,
  UpdateEmailerDataPayloadType,
  UpdateHolidayCalenderPayloadType,
  UpdateJobTitlePayloadType,
  UpdatePdfTemplatePayloadType,
  UpdateQualificationPayloadType,
  UpdateSkillsPayloadType,
  UpdateUsersDepartmentPayloadType,
} from "../../commonTypes/masterDataTypes";

export const createMasterDataBranchAction = createAsyncThunk(
  "create/branch",
  async (data: CreateBranchDataPayloadType) => {
    const response = await createMasterDataBranchApi(data);
    return response.data;
  }
);
export const getMasterDataBranchAction = createAsyncThunk(
  "get/branch",
  async (data: GetAllMasterDataBranchPayloadType) => {
    const response = await getMasterDataBranchApi(data);

    return response.data;
  }
);
export const updateMasterDataBranchAction = createAsyncThunk(
  "update/branch",
  async (data: UpdateBranchDataPayloadType) => {
    const response = await updateMasterDataBranchApi(data);
    return response.data;
  }
);

//Client Group

export const createMasterClientGroupAction = createAsyncThunk(
  "create/ClientGroup",
  async (data: CreateClientGroupDataPayloadType) => {
    const response = await createMasterDataClientGroupApi(data);
    return response.data;
  }
);
export const getMasterDataClientGroupAction = createAsyncThunk(
  "get/ClientGroup",
  async (data: GetClientGroupDataPayloadType) => {
    const response = await getMasterDataClientGroupApi(data);

    return response.data;
  }
);
export const updateMasterDataClientGroupAction = createAsyncThunk(
  "update/ClientGroup",
  async (data: UpdateClientGroupDataPayloadType) => {
    const response = await updateMasterDataClientGroupApi(data);
    return response.data;
  }
);

export const checkUniqueClientGroupNameAction = createAsyncThunk(
  "master/checkUniqueClientGroupName",
  async (data: UniqueClientGroupNamePayloadType) => {
    const response = await checkUniqueClientGroupNameApi(data);
    return response;
  }
);

export const createMasterDataActivityCodeAction = createAsyncThunk(
  "create/activityCode",
  async (data: CreateActivityCodeDataPayloadType) => {
    const response = await createMasterDataActivityCodeApi(data);
    return response.data;
  }
);
export const checkUniqueBranchNameAction = createAsyncThunk(
  "master/checkUniqueBranchName",
  async (data: UniqueMasterDataPayloadType) => {
    const response = await checkUniqueBranchNameApi(data);
    return response;
  }
);


export const checkUniquePdfTemplateNameAction=createAsyncThunk(
  "master/checkUniquePdfTemplateName",
  async (data: UniqueMasterDataPayloadType) => {
    const response = await checkUniquePdfTemplateApi(data);
    return response;
  }
);

export const getMasterDataActivityCodeAction = createAsyncThunk(
  "get/activityCode",
  async (data: GetAllMasterDataActivityCodePayloadType) => {
    const response = await getMasterDataActivityCodeApi(data);

    return response.data;
  }
);
export const updateMasterDataActivityCodeAction = createAsyncThunk(
  "update/activityCode",
  async (data: UpdateActivityCodeDataPayloadType) => {
    const response = await updateMasterDataActivityCodeApi(data);
    return response.data;
  }
);
export const getAllMasterDataBranchAction = createAsyncThunk(
  "getAll/BranchDataList",
  async (data: GetAllMasterDataBranchPayloadType) => {
    const response = await getAllMasterDataBranchListApi(data);
    return response.data;
  }
);

export const getAllMasterDataActivityCodeAction = createAsyncThunk(
  "getAll/ActivityCodeList",
  async (data: GetAllMasterDataActivityCodePayloadType) => {
    const response = await getAllMasterDataActivityCodeListApi(data);
    return response.data;
  }
);

// currency

export const createMasterDataCurrencyAction = createAsyncThunk(
  "create/currency",
  async (data: CreateCurrencyDataPayloadType) => {
    const response = await createMasterDataCurrencyApi(data);
    return response.data;
  }
);

export const getMasterDataCurrencyAction = createAsyncThunk(
  "get/currency",
  async (data: string | null) => {
    const response = await getMasterDataCurrencyApi(data);

    return response.data;
  }
);
export const updateMasterDataCurrencyAction = createAsyncThunk(
  "update/currency",
  async (data: UpdateCurrencyDataPayloadType) => {
    const response = await updateMasterDataCurrencyApi(data);
    return response.data;
  }
);

export const getAllMasterDataCurrencyAction = createAsyncThunk(
  "getAll/currency",
  async (data: GetAllMasterDataCurrencyPayloadType) => {
    const response = await getAllMasterDataCurrencyListApi(data);
    return response.data;
  }
);

// emailers
export const createMasterEmailersAction = createAsyncThunk(
  "create/Emailers",
  async (data: CreateEmailersDataPayloadType) => {
    const response = await createMasterDataEmailersApi(data);
    return response.data;
  }
);
export const getMasterDataEmailersAction = createAsyncThunk(
  "get/Emailers",
  async (data: GetEmailerDataPayloadType) => {
    const response = await getMasterDataEmailersApi(data);

    return response.data;
  }
);
export const updateMasterDataEmailersAction = createAsyncThunk(
  "update/Emailers",
  async (data: UpdateEmailerDataPayloadType) => {
    const response = await updateMasterDataEmailersApi(data);
    return response.data;
  }
);

// holiday calender

export const getMasterDataHolidayCalenderAction = createAsyncThunk(
  "get/holidayCalender",
  async (data: GetHolidayCalenderPayloadType) => {
    const response = await getMasterDataHolidayCalenderApi(data);

    return response.data;
  }
);
export const createMasterHolidayCalenderAction = createAsyncThunk(
  "create/holidayCalender",
  async (data: CreateHolidayCalenderPayloadType) => {
    const response = await createMasterDataHolidayCalenderApi(data);
    return response.data;
  }
);

export const updateMasterDataHolidayCalenderAction = createAsyncThunk(
  "update/holidayCalender",
  async (data: UpdateHolidayCalenderPayloadType) => {
    const response = await updateMasterDataHolidayCalenderApi(data);
    return response.data;
  }
);
export const deleteHolidayCalenderAction = createAsyncThunk(
  "delete/holidayCalender",
  async (data: DeleteHolidayCalenderPayloadType) => {
    const response = await deleteHolidayCalenderApi(data);
    return response.data;
  }
);

//  country
export const getAllCountryAction = createAsyncThunk(
  "get/country",
  async (data: GetCountryListDataPayloadType) => {
    const response = await getAllCountryApi(data);
    return response.data;
  }
);

export const getAllCityAction = createAsyncThunk(
  "get/city",
  async (data: GetCityListDataPayloadType) => {
    const response = await getAllCityApi(data);
    return response.data;
  }
);

export const getAllCityPermanentAddressAction = createAsyncThunk(
  "get/cityPermanentAddress",
  async (data: GetCityListDataPayloadType) => {
    const response = await getAllCityApi(data);
    return response.data;
  }
);

export const getAllStateAction = createAsyncThunk(
  "get/state",
  async (data: GetStateListDataPayloadType) => {
    const response = await getAllStateApi(data);
    return response.data;
  }
);

export const getAllStatePermanentAddressAction = createAsyncThunk(
  "get/permanentAddressState",
  async (data: GetStateListDataPayloadType) => {
    const response = await getAllStateApi(data);
    return response.data;
  }
);

//  curencyExchange
export const getCurrencyExchangeAction = createAsyncThunk(
  "get/currency",
  async (data: GetCurrencyExchangeDetailsPayloadType) => {
    const response = await getCurrnecyExchangeApi(data);
    return response.data;
  }
);

// client category
export const getMasterDataClientCategoryAction = createAsyncThunk(
  "get/clientCategory",
  async (data: GetClientCategoryPayloadType) => {
    const response = await getMasterDataClientCategoryApi(data);
    return response.data;
  }
);

export const createMasterDataClientCategoryAction = createAsyncThunk(
  "create/clientCategory",
  async (data: AddClientCategoryPayloadType) => {
    const response = await createMasterDataClientCategoryApi(data);
    return response.data;
  }
);

export const updateMasterDataClientCategoryAction = createAsyncThunk(
  "update/clientCategory",
  async (data: UpdateClientCategoryPayloadType) => {
    const response = await updateMasterDataClientCategoryApi(data);
    return response.data;
  }
);
//User's Department
export const getMasterDataUsersDepartmentAction = createAsyncThunk(
  "get/usersdepartment",
  async (data: GetUsersDepartmentPayloadType) => {
    const response = await getMasterDataUsersDepartmentApi(data);
    return response.data;
  }
);

export const createMasterDataUsersDepartmentAction = createAsyncThunk(
  "create/usersdepartment",
  async (data: AddUsersDepartmentPayloadType) => {
    const response = await createMasterDataUsersDepartmentApi(data);
    return response.data;
  }
);

export const updateMasterDataUsersDepartmentAction = createAsyncThunk(
  "update/usersdepartment",
  async (data: UpdateUsersDepartmentPayloadType) => {
    const response = await updateMasterDataUsersDepartmentApi(data);
    return response.data;
  }
);

export const deleteMasterDataUsersDepartmentAction = createAsyncThunk(
  "delete/usersdepartment",
  async (data: DeleteUsersDepartmentPayloadType) => {
    const response = await deleteMasterDataUsersDepartmentApi(data);
    return response.data;
  }
);

//Tds Module
//User's Department
export const getMasterTdsModuleAction = createAsyncThunk(
  "get/tdsmodule",
  async (data: GetTdsMasterPayloadType) => {
    const response = await getMasterTdsModuleApi(data);
    return response.data;
  }
);

export const getMasterTdsModuleSingleAction = createAsyncThunk(
  "get/tdsSinglemodule",
  async (data: TdsSinglePayloadType) => {
    const response = await getMasterTdsModuleSingleApi(data);
    return response.data;
  }
);



export const createMasterTdsModuleAction = createAsyncThunk(
  "create/tdsmodule",
  async (data: TdsInfoType) => {
    const response = await createMasterTdsModuleApi(data);
    return response.data;
  }
);

export const updateMasterTdsModuleAction = createAsyncThunk(
  "update/tdsmodule",
  async (data: TdsInfoType) => {
    const response = await updateMasterTdsModuleApi(data);
    return response.data;
  }
);

export const deleteMasterTdsModuleAction = createAsyncThunk(
  "delete/tdsmodule",
  async (data: DeleteTdsPayloadType) => {
    const response = await deleteMasterTdsModuleApi(data);
    return response.data;
  }
);

// Skills Module
export const getMasterDataSkillsModuleAction = createAsyncThunk(
  "get/skillsModule",
  async (data: GetUsersDepartmentPayloadType) => {
    const response = await getMasterDataSkillsModuleApi(data);
    return response.data;
  }
);
export const createMasterDataSkillsModuleAction = createAsyncThunk(
  "create/skillsModule",
  async (data: AddSkillsPayloadType) => {
    const response = await createMasterDataSkillsModuleApi(data);
    return response.data;
  }
);
export const updateMasterDataSkillsModuleAction = createAsyncThunk(
  "update/skillsModule",
  async (data: UpdateSkillsPayloadType) => {
    const response = await updateMasterDataSkillsModuleApi(data);
    return response.data;
  }
);
export const deleteMasterDataSkillsAction = createAsyncThunk(
  "delete/skillsModule",
  async (data: DeleteSkillsPayloadType) => {
    const response = await deleteMasterDataSkillsApi(data);
    return response.data;
  }
);
// Education/Qualification module
export const getMasterDataQualificationModuleAction = createAsyncThunk(
  "get/qualification/educationModule",
  async (data: GetMasterDataListPayloadType) => {
    const response = await getMasterDataQualificationModuleApi(data);
    return response.data;
  }
);
export const createMasterDataQualificationModuleAction = createAsyncThunk(
  "create/qualification/educationModule",
  async (data: AddQualificationPayloadType) => {
    const response = await createMasterDataQualificationModuleApi(data);
    return response.data;
  }
);
export const updateMasterDataQualificationModuleAction = createAsyncThunk(
  "update/qualification/educationModule",
  async (data: UpdateQualificationPayloadType) => {
    const response = await updateMasterDataQualificationModuleApi(data);
    return response.data;
  }
);
export const deleteMasterDataQualificationAction = createAsyncThunk(
  "delete/qualification/educationModule",
  async (data: DeleteQualificationPayloadType) => {
    const response = await deleteMasterDataQualificationApi(data);
    return response.data;
  }
);
// scope of work
export const getMasterDataScopeOfWorkAction = createAsyncThunk(
  "get/scopeOfWork",
  async (data: any) => {
    const response = await getMasterDataScopeOfWorkApi(data);
    return response.data;
  }
);
export const createMasterDataScopeOfWorkAction = createAsyncThunk(
  "create/scopeOfWork",
  async (data: any) => {
    const response = await createMasterDataScopeOfWorkApi(data);
    return response.data;
  }
);
export const updateMasterDataScopeOfWorkAction = createAsyncThunk(
  "update/scopeOfWork",
  async (data: any) => {
    const response = await updateMasterDataScopeOfWorkApi(data);
    return response.data;
  }
);
export const deleteMasterDataScopeOfWorkAction = createAsyncThunk(
  "delete/scopeOfWork",
  async (data: any) => {
    const response = await deleteMasterDataScopeOfWorkApi(data);
    return response.data;
  }
);

// TCS module
export const getMasterTcsModuleAction = createAsyncThunk(
  "get/tcsmodule",
  async (data: GetTdsMasterPayloadType) => {
    const response = await getMasterTcsModuleApi(data);
    return response.data;
  }
);

export const getMasterTcsModuleSingleAction = createAsyncThunk(
  "get/tcsSinglemodule",
  async (data: TcsSinglePayloadType) => {
    const response = await getMasterTcsModuleSingleApi(data);
    return response.data;
  }
);



export const createMasterTcsModuleAction = createAsyncThunk(
  "create/tcsmodule",
  async (data: TcsInfoType) => {
    const response = await createMasterTcsModuleApi(data);
    return response.data;
  }
);

export const updateMasterTcsModuleAction = createAsyncThunk(
  "update/tcsmodule",
  async (data: TcsInfoType) => {
    const response = await updateMasterTcsModuleApi(data);
    return response.data;
  }
);

export const deleteMasterTcsModuleAction = createAsyncThunk(
  "delete/tcsmodule",
  async (data: DeleteTcsPayloadType) => {
    const response = await deleteMasterTcsModuleApi(data);
    return response.data;
  }
);

export const checkUniqueCode = createAsyncThunk(
  "check/tcstdsCode",
  async (data: UniqueCheckCodePayloadType) => {
    const response = await checkUniqueCodeApi(data);
    return response.data;
  }
);


export const getMasterPdfTemplateListAction = createAsyncThunk(
  "get/pdfTemplate",
  async (data: GetMasterDataListPayloadType) => {
    const response = await getMasterPdfTemplateApi(data);
    return response.data;
  }
);

export const createMasterPdfTemplateAction = createAsyncThunk(
  "create/pdfTemplate",
  async (data: AddPdfTemplatePayloadType) => {
    const response = await createMasterPdfTemplateApi(data);
    return response.data;
  }
);

export const updateMasterPdfTemplateAction = createAsyncThunk(
  "update/pdfTemplate",
  async (data: UpdatePdfTemplatePayloadType) => {
    const response = await updateMasterPdfTemplateApi(data);
    return response.data;
  }
);

export const deleteMasterPdfTemplateAction = createAsyncThunk(
  "delete/pdfTemplate",
  async (data: DeletePdfTemplatePayloadType) => {
    const response = await deleteMasterPdfTemplateApi(data);
    return response.data;
  }
);

// job title

export const getMasterDataJobTitleAction = createAsyncThunk(
  "get/jobTitle",
  async (data: GetJobTitlePayloadType) => {
    const response = await getMasterDataJobTitleApi(data);
    return response.data;
  }
);

export const createMasterDataJobTitleAction = createAsyncThunk(
  "create/jobTitle",
  async (data: AddJobTitlePayloadType) => {
    const response = await createMasterDataJobTitleApi(data);
    return response.data;
  }
);

export const updateMasterDataJobTitleAction = createAsyncThunk(
  "update/jobTitle",
  async (data: UpdateJobTitlePayloadType) => {
    const response = await updateMasterDataJobTitleApi(data);
    return response.data;
  }
);

export const deleteMasterDataJobTitleAction = createAsyncThunk(
  "delete/jobTitle",
  async (data: DeleteJobTitlePayloadType) => {
    const response = await deleteMasterDataJobTitleApi(data);
    return response.data;
  }
);